import { Box, Typography } from "@mui/material";
import { ResponsiveBar } from "@nivo/bar";
import { getColorFromPercentile } from "../utils";
import { getTableData } from "./utils";
import { UsageAndEfficiencyChartProps } from "./types";
import { getReadableRowLabel } from "../TeamReportDataTable/utils";

export default function UsageAndEfficiencyChart({
  rows,
  title,
  width,
  height,
}: UsageAndEfficiencyChartProps) {
  if (!rows || !Array.isArray(rows) || rows.length === 0) {
    return <Typography>No data available</Typography>;
  }
  const chartData = getTableData(rows);

  return (
    <Box
      sx={{
        height: height ?? 400,
        width: width ?? "100%",
        position: "relative",
      }}
    >
      <ResponsiveBar
        data={chartData}
        keys={["Poss"]}
        indexBy="rowType"
        layout="horizontal"
        labelSkipWidth={0}
        labelSkipHeight={0}
        padding={0.3}
        colors={({ data }) =>
          getColorFromPercentile(data.pppPercentile, data.pppRank)
        }
        label={({ indexValue, data }) =>
          `${getReadableRowLabel(indexValue)} (${(data.ppp / 100).toFixed(2)})`
        }
        labelOffset={4}
        labelPosition="start"
        enableGridY={false}
        axisBottom={{
          legend: "Possessions",
          legendOffset: 40,
        }}
        borderColor="#bbb"
        borderWidth={1}
        borderRadius={0}
        axisLeft={null}
        margin={{ top: -5, right: 10, bottom: 60, left: 10 }}
        theme={{
          labels: {
            text: {
              fontWeight: 700,
              filter: "drop-shadow(rgba(255, 255, 255, 0.4) 1px 1px 0px) drop-shadow(rgba(255, 255, 255, 0.4) -1px 1px 0px) drop-shadow(rgba(255, 255, 255, 0.4) 1px -1px 0px) drop-shadow(rgba(255, 255, 255, 0.4) -1px -1px 0px)",
            },
          },
        }}
      />
      {title && (
        <Typography
          variant="h5"
          sx={{
            position: "absolute",
            bottom: 65,
            right: 16,
            fontWeight: "bold",
            maxWidth: 200,
            textAlign: "right",
          }}
        >
          {title}
        </Typography>
      )}
    </Box>
  );
}
